
export const transferrableAttachments = <const>['poster'];
export type TransferrableAttachment = typeof transferrableAttachments[number];

/**
 * The AttachmentType should only include the Attachment File Type : 'image', 'subtitle', 'file'.
 * The poster and prproj is only included to maintain backward compatibility for third-party integration.
 */
export const attachmentTypes = <const>['prproj', 'drp', 'image', 'subtitle', 'file', 'sequence', ...transferrableAttachments];
export type AttachmentType = typeof attachmentTypes[number];

/**
 * Thumbnail property does the same thing as poster, but included to maintain backward compatibility.
 */
export const attachmentRoles = <const>['thumbnail', 'poster', 'subtitle', 'file'];
export type AttachmentRole = typeof attachmentRoles[number];

